'use strict'

export const DURATIONS = [
  { key: '15 minutes', value: 15 },
  { key: '30 minutes', value: 30 },
  { key: '45 minutes', value: 45 },
  { key: '1 hour', value: 60 },
  { key: '1.5 hours', value: 90 },
  { key: '2 hours', value: 120 },
  { key: '2.5 hours', value: 150 },
  { key: '3 hours', value: 180 },
  { key: '4 hours', value: 240 },
  { key: '5 hours', value: 300 }
]

export const PERIODS = [
  { key: 'One time meeting', value: 1 },
  { key: 'Daily', value: 365 },
  { key: 'Twice a week', value: 182 },
  { key: 'Weekly', value: 52 },
  { key: 'Fortnight', value: 26 },
  { key: 'Monthly', value: 12 },
  { key: 'Quartely', value: 4 },
  { key: 'Yearly', value: '01' }
]

export const SETUP = [
  { key: '0 minutes', value: 0 },
  { key: '5 minutes', value: 5 },
  { key: '10 minutes', value: 10 },
  { key: '15 minutes', value: 15 },
  { key: '20 minutes', value: 20 },
  { key: '30 minutes', value: 30 },
  { key: '60 minutes', value: 60 }
]

export const ATTENDEES = Array.from(new Array(50)).map((obj, index) => {
  const key = index === 0 ? '1 attendee' : `${index + 1} attendees`
  return { key, value: index + 1 }
})

export const SALARIES = Array.from(new Array(100)).map((obj, index) => {
  const baseSalary = 1000
  const salary = (index + 1) * baseSalary
  return { key: salary, value: salary }
})
